import React from 'react';
import PropTypes from 'prop-types';

const LogoMini = ({ style, ...rest }) => {
  return (
    <img
      alt="Logo"
      src="/static/logoMini.svg"
      style={{
        display: 'block', height: 38, width: 'auto', ...style
      }}
      {...rest}
    />
  );
};

LogoMini.propTypes = {
  style: PropTypes.objectOf(PropTypes.any)
};

export default LogoMini;
